module.exports = __webpack_public_path__ + "static/img/btn_tou_nor.ed9a6ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_tou_nor.png
// module id = 3bI8
// module chunks = 1